import { ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

// Constantes du jeu
export const GAME_CONSTANTS = {
  MIN_PLAYERS: 2,
  MAX_PLAYERS: 8,
  ROUNDS_PER_GAME: 10,
  MIN_TRICKS: 0
};

// Couleurs pour les joueurs (pour les graphiques)
export const PLAYER_COLORS = [
  '#2563eb', // Bleu
  '#dc2626', // Rouge
  '#16a34a', // Vert
  '#9333ea', // Violet
  '#ea580c', // Orange
  '#0d9488', // Turquoise 
  '#db2777', // Rose
  '#84cc16'  // Vert clair
];

// Messages d'erreur
export const ERROR_MESSAGES = {
  INVALID_PLAYER_COUNT: `Le nombre de joueurs doit être entre ${GAME_CONSTANTS.MIN_PLAYERS} et ${GAME_CONSTANTS.MAX_PLAYERS}`,
  INVALID_PREDICTION: 'La prédiction doit être entre 0 et le nombre de plis de la manche',
  DUPLICATE_NAME: 'Ce nom de joueur existe déjà',
  EMPTY_NAME: 'Le nom du joueur ne peut pas être vide'
};

// Animations
export const ANIMATION_VARIANTS = {
  pageTransition: {
    initial: { opacity: 0, x: -20 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: 20 }
  },
  scoreReveal: {
    hidden: { scale: 0, opacity: 0 },
    visible: { scale: 1, opacity: 1 }
  }
};

// Utilitaire pour combiner les classes Tailwind
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Routes de l'application
export const ROUTES = {
  SELECTOR: '/',
  HOME: '/skull-king',
  FLIP7: '/flip-7',
  SKYJO: '/skyjo',
  GAME: '/game',
  RESULTS: '/results',
  LEGAL: '/mentions-legales',
  PRIVACY: '/confidentialite'
};

// Format des données pour le localStorage
export const STORAGE_KEYS = {
  GAME_STATE: 'skullking_state_v3',
  SETTINGS: 'skullking_settings_v2',
};

// Messages de confirmation
export const CONFIRM_MESSAGES = {
  RESET_GAME: 'Êtes-vous sûr de vouloir recommencer la partie ?',
  NEXT_ROUND: 'Valider les scores et passer à la manche suivante ?'
};

// Points d'intérêt pour les tooltips (aide)
export const TOOLTIPS = {
  ZERO_PREDICTION: 'Prédire 0 rapporte 10 points × le numéro de la manche en cas de réussite',
  SCORING_RULES: 'Prédiction réussie : 20 points × nombre prédit\nPrédiction manquée : -10 points × différence'
};
